angular.module('qkr').directive('templateBuilder', ['formBuilderService', 'merchantService', 'messageService',
    'FormHelper', '$timeout',  'appConfig', '$window', 'utils', '$uibModal', 'gettextCatalog', '$location',
    function(formBuilderService, merchantService, messageService, FormHelper, $timeout, appConfig, $window, utils,
             $uibModal, gettextCatalog, $location) {
	return {
		restrict: 'E',
		template: require('../../directives/forms/template_builder.html'),
		replace: true,
		scope: {
			template: '='
		},
		link(scope, element, attrs, controller) {
			setUp();

			scope.addFormElement = function(type, label, required, helperText, fieldId) {
                required = typeof required !== 'undefined' ? required : false; // Optional arg, default to false
				const formElement = {};
				formElement.type = type;
				formElement.label = (label == null) ? '' : label;
                formElement.helperText = (helperText == null) ? '' : helperText;
                formElement.fieldId = (fieldId == null) ? scope.template.formElements.length + 1 : fieldId;
                if (type != 'Paragraph') {
                    formElement.required = required;
                }
				scope.template.formElements.push(formElement);
			};

			scope.addFormElementFullName = function(isSignatureRequired) {
			    if (isSignatureRequired) {
                    scope.addFormElement('Text', 'Full Name of Signatory', true, '', 'signatureFullName');
			    } else {
                    let signatureElementIndex = -1;
                    for (let i = 0; i < scope.template.formElements.length; i++) {
                        if (scope.template.formElements[i].fieldId == 'signatureFullName') {
                            signatureElementIndex = i;
                        }
                    }
                    if (signatureElementIndex >= 0) {
                        scope.template.formElements[signatureElementIndex].deleted = true;
                    }
			    }
			};

			scope.cancel = function() {
				$location.path('/forms');
				utils.scrollToTop();
			};

			scope.save = function(andPreview) {
                if (!validate()) {
		            return;
		        }

                scope.addOrRemoveSignature();

		        scope.saving = true;

				if (scope.template.id == null) {
					var templateCommand = generateCreateTemplateCommand();

					formBuilderService.createTemplate(templateCommand).then((data) => {
						const resp = scope.formHelper.handleResponse(data);

						if (resp.success) {
							scope.template = data;
                            scope.determineIsSignatureRequired();
                            scope.saving = false;
                            if (andPreview) {
                                scope.showPreview();
                            } else {
                                messageService.success('Template updated');
                                window.setTimeout(() => {
                                    $window.location.href = appConfig.contextPath + '/app/storeFront#/forms/';
                                }, 2000);
                            }
						} else {
							messageService.error(gettextCatalog.getString('Error, template could not be created.') + ' ' + data.exception);
						}

						$timeout(() => {
							scope.saving = false;
						});
					})
					.catch(err => messageService.errorWithReason(err, 'Error with template creation', false));
					scope.saving = false;
				} else {
					var templateCommand = generateUpdateTemplateCommand();

					formBuilderService.updateTemplate(templateCommand).then((data) => {
						const resp = scope.formHelper.handleResponse(data);
						if (resp.success) {
							scope.template = data;
                            scope.determineIsSignatureRequired();
                            scope.saving = false;
                            if (andPreview) {
                                scope.showPreview();
                            } else {
                                messageService.success(gettextCatalog.getString('Template updated'));
                                window.setTimeout(() => {
                                    $window.location.href = appConfig.contextPath + '/app/storeFront#/forms/';
                                }, 2000);
                            }
						} else {
							messageService.error(gettextCatalog.getString('Error, template could not be updated.') + data.exception);
						}

						$timeout(() => {
							scope.saving = false;
						});
					}).catch(err => messageService.errorWithReason(err, 'Error with template update', false));
					scope.saving = false;
				}
			};

            scope.showPreview = function() {
                const previewModal = $uibModal.open({
                    template: require('../../directives/forms/previewModal.html'),
                    controller: 'PreviewModalInstanceCtrl',
                    size: 'sm',
					backdrop: 'static',
                    resolve: {
                        previewTemplate() {
                            return scope.template;
                        }
                    }
                });
            };

            scope.determineIsSignatureRequired = function() {
                scope.template.isSignatureRequired = false;
                for (let i = 0; i < scope.template.formElements.length; i++) {
                    const el = scope.template.formElements[i];
                    if (el.type == 'Signature') {
                        scope.template.isSignatureRequired = true;
                    }
                }
            };

            scope.addOrRemoveSignature = function() {
                const signatureElementIndex = scope.findSignatureElementIndex();
                if (scope.template.isSignatureRequired) {
                    if (signatureElementIndex == -1) {
                        // Need to add
                        scope.addFormElement('Signature', '');
                    }
                } else if (signatureElementIndex != -1) {
                        // Need to remove
                        scope.template.formElements[signatureElementIndex].deleted = true;
                    }
            };

            scope.findSignatureElementIndex = function() {
                for (let i = 0; i < scope.template.formElements.length; i++) {
                    if (scope.template.formElements[i].type == 'Signature') {
                        return i;
                    }
                }
                return -1;
            };

            scope.enterNameNext = function(formIsInvalid) {
                if(formIsInvalid) {
                    return;
                }
                if (scope.template.name.length > 0) {
                    scope.creatingStep1 = false;
                }
            };

			function setUp() {
				scope.saving = false;
                scope.previewVisible = false;
				scope.formHelper = new FormHelper(scope);
				merchantService.loadMerchantInfo().then((merchant) => {
					scope.merchant = merchant;
				});
                scope.creatingStep1 = false;
                if (scope.template && !scope.template.id) {
                    scope.creatingStep1 = true;
                    scope.template.isConsentRequired = true;
                }
			}

			function generateCreateTemplateCommand() {
				const templateCommand = {};
				templateCommand.name = scope.template.name;
				templateCommand.isConsentRequired = scope.template.isConsentRequired;
				templateCommand.termsAndConditionsUrl = scope.template.termsAndConditionsUrl;
				templateCommand.formElements = generateAddFormElements();

				return templateCommand;
			}

			function generateUpdateTemplateCommand() {
				const templateCommand = {};
				templateCommand.id = scope.template.id;
				templateCommand.name = scope.template.name;
				templateCommand.isConsentRequired = scope.template.isConsentRequired;
				templateCommand.termsAndConditionsUrl = scope.template.termsAndConditionsUrl;
				templateCommand.addFormElements = generateAddFormElements();
				templateCommand.updateFormElements = generateUpdateFormElements();
				templateCommand.deleteFormElements = generateDeleteFormElements();

				return templateCommand;
			}

			function generateAddFormElements() {
				const addFormElements = [];
				angular.forEach(scope.template.formElements, (formElement, $index) => {
					if (formElement.id == null && !formElement.deleted) {
						const formElementCommand = generateFormElementCommand(formElement, $index);
						addFormElements.push(formElementCommand);
					}
				});

				return addFormElements;
			}

			function generateUpdateFormElements() {
				const updateFormElements = [];
				angular.forEach(scope.template.formElements, (formElement, $index) => {
					if (formElement.id != null && !formElement.deleted) {
						const formElementCommand = generateFormElementCommand(formElement, $index);
						updateFormElements.push(formElementCommand);
					}
				});

				return updateFormElements;
			}

			function generateFormElementCommand(formElement, position) {
				const formElementCommand = {};
				if (formElement.id != null) {
					formElementCommand.id = formElement.id;
				}

				formElementCommand.label = formElement.label;
				formElementCommand.type = formElement.type;
				formElementCommand.required = formElement.required != null ? formElement.required : false;
				formElementCommand.position = position;
				formElementCommand.options = {choices: generateFormElementChoices(formElement)};

				return formElementCommand;
			}

			function generateDeleteFormElements() {
				const deleteFormElements = [];
				angular.forEach(scope.template.formElements, (formElement, $index) => {
					if (formElement.id != null && formElement.deleted) {
						const formElementId = {id: formElement.id};
						deleteFormElements.push(formElementId);
					}
				});

				return deleteFormElements;
			}

			function generateFormElementChoices(formElement) {
				const formElementChoices = [];

				angular.forEach(formElement.tags, (option, $index) => {
					const optionCommand = {};
					optionCommand.label = option;
					optionCommand.default = false;
					formElementChoices.push(optionCommand);
				});

				return formElementChoices;
			}

			function validate() {
		        let valid = true;
		        const errors = {};
		        let deleted = 0;

		        errors.formElement = [];
		        // No undeleted fields
		        angular.forEach(scope.template.formElements, (formElement) => {
		            const formElementErrors = {};
                    if (formElement.type != 'Signature') {
                        if (formElement.deleted == true) {
                            deleted++;
                        } else {
                            if (utils.hasNoValue(formElement.label)) {
                                valid = false;
                                formElementErrors.label = gettextCatalog.getString('A label for this field is required');
                            }
                            if ((formElement.type == 'CheckBoxList' || formElement.type == 'OptionList') && formElement.tags.length < 1) {
                                valid = false;
                                formElementErrors.tags = gettextCatalog.getString('At least one option is required');
                            }
                        }
                        errors.formElement.push(formElementErrors);
                    }
		        });

		        if (deleted == scope.template.formElements.length) {
                    valid = false;
                    errors.noFields = gettextCatalog.getString('At least one field is required');
		        }

                if (utils.hasNoValue(scope.template.name)) {
                    valid = false;
                    errors.name = gettextCatalog.getString('Please provide a name for this template');
                }

                scope.errors = errors;
                return valid;
			}
		}
	};
}]);

angular.module('qkr').controller('PreviewModalInstanceCtrl', ($scope, $sce, previewTemplate, appConfig, messageService,
															  $window, gettextCatalog) => {
    $scope.previewTemplate = previewTemplate;

    $scope.previewUrl = function() {
        const url = appConfig.serverHost + '/' + appConfig.serverPath + '/form/preview?templateId=' + $scope.previewTemplate.id;
        return $sce.trustAsResourceUrl(url);
    };

    $scope.closePreview = function() {
		$scope.$close('cancel');
		messageService.success(gettextCatalog.getString('Template updated'));
		$window.setTimeout(() => {
			$window.location.href = appConfig.contextPath + '/app/storeFront#/forms/';
		}, 2000);
    };
});



// WEBPACK FOOTER //
// ./src/directives/forms/template_builder.js